var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google 1",
    clipPath: "url(#clip0_936_1867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.46429 12.005L3.76311 14.5894L1.20033 14.6429C0.434429 13.2403 0 11.6356 0 9.93039C0 8.28141 0.40618 6.7264 1.12616 5.35718H1.12671L3.40831 5.77017L4.40779 8.00931C4.1986 8.61143 4.08458 9.2578 4.08458 9.93039C4.08466 10.6603 4.21859 11.3597 4.46429 12.005Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M19.8244 8.21423C19.9398 8.81768 19.9999 9.44088 19.9999 10.0778C19.9999 10.792 19.9243 11.4886 19.7803 12.1606C19.2914 14.4473 18.0141 16.4441 16.2446 17.8571L16.244 17.8565L13.3787 17.7113L12.9732 15.1966C14.1473 14.5126 15.0649 13.4421 15.5483 12.1606H10.1785V8.21423H15.6266H19.8244Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M16.2495 17.8135L16.25 17.8141C14.5441 19.1817 12.3771 20 10.0181 20C6.22721 20 2.93133 17.8866 1.25 14.7766L4.4759 12.1428C5.31654 14.3805 7.48081 15.9735 10.0181 15.9735C11.1087 15.9735 12.1304 15.6794 13.0072 15.1661L16.2495 17.8135Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M16.4286 2.29294L13.2073 4.93447C12.3009 4.367 11.2295 4.03918 10.0817 4.03918C7.48981 4.03918 5.28748 5.71044 4.48983 8.03571L1.25054 5.3794H1.25C2.90489 2.1835 6.23868 0 10.0817 0C12.4943 0 14.7065 0.860825 16.4286 2.29294Z",
    fill: "#F14336"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_1867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.cd94981242da039686617d95db931bb4.svg";
export { ForwardRef as ReactComponent };